export default "__VITE_ASSET__CzBs9tQL__"